module.exports = __webpack_public_path__ + "static/img/SketchPngc9c141eaeaaf2be8dacbfddda139af6a069217d1a418dac9b8ba9f07fb13dbf8.53c06d10.png";